/*
 * Proyectos: lo que pasa después de la propuesta. Activos con fase, plan e
 * indicador a la vista; por arrancar y cerrados como listas.
 */

import { useNavigate } from "react-router-dom";

import { useProyectos } from "../api/hooks";
import { FASES_PROYECTO, nombreEquipo, type Proyecto } from "../api/tipos";
import { Abierto, CabeceraSeccion, Esqueleto, fmtFecha } from "../ui/primitivas";
import { KpiGrande, PillKpi, StepperFases, estadoKpi, estadoPlan, unidad } from "../ui/proyecto";

export function Proyectos() {
  const nav = useNavigate();
  const { data, isLoading } = useProyectos();
  const todos = data ?? [];
  const activos = todos.filter((p) => p.estado === "activo"), porA = todos.filter((p) => p.estado === "por_arrancar"), cerr = todos.filter((p) => p.estado === "cerrado");
  const fila = (p: Proyecto, derecha: React.ReactNode) => (
    <button key={p.id} onClick={() => nav(`/proyectos/${p.id}`)} className="fila-hover" style={{ display: "flex", width: "100%", alignItems: "center", gap: 14, padding: "12px 18px" }}>
      <span style={{ flex: 1, minWidth: 0 }}><span style={{ display: "block", fontWeight: 500, fontSize: 14 }}>{p.nombre}</span><span style={{ display: "block", color: "var(--muted)", fontSize: 12.5 }}>{p.cuenta} · {p.indicador.nombre}</span></span>
      {derecha}
      <span style={{ color: "var(--sky)", fontSize: 13, fontWeight: 500 }}>→</span>
    </button>
  );
  return (
    <div className="pagina" style={{ maxWidth: 1100 }}>
      <header style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 16, marginBottom: 20 }}>
        <h1 className="titulo">Proyectos</h1>
        <span style={{ fontSize: 12.5, color: "var(--faint)" }}>Nacen al aceptar una propuesta; se arrancan desde la cuenta.</span>
      </header>
      {isLoading && <div className="tarjeta"><Esqueleto lineas={4} /></div>}
      {data && todos.length === 0 && <Abierto>Todavía sin proyectos. El primero nace cuando un cliente acepta una propuesta.</Abierto>}
      {activos.length > 0 && (
        <section style={{ marginBottom: 28 }}>
          <CabeceraSeccion titulo="Activos" n={activos.length} />
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {activos.map((p) => {
              const plan = estadoPlan(p), f = FASES_PROYECTO[p.fase];
              const abiertas = p.tareas.filter((t) => t.estado !== "hecho").length, bloq = p.tareas.filter((t) => t.estado === "bloqueado").length;
              return (
                <article key={p.id} className="tarjeta" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px,1fr))", gap: "20px 32px", padding: "20px 24px" }}>
                  <div style={{ minWidth: 0, display: "flex", flexDirection: "column", gap: 14 }}>
                    <button onClick={() => nav(`/proyectos/${p.id}`)}>
                      <span style={{ display: "block", fontSize: 13, color: "var(--muted)", fontWeight: 500 }}>{p.cuenta}</span>
                      <span className="subtitulo" style={{ display: "block", fontSize: 19, letterSpacing: "-0.01em", lineHeight: 1.25 }}>{p.nombre}</span>
                    </button>
                    <div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 8, gap: 12, flexWrap: "wrap" }}>
                        <span style={{ fontSize: 13.5, fontWeight: 500, whiteSpace: "nowrap" }}><span className="mono" style={{ color: "var(--sky)", marginRight: 6 }}>{f.id}</span>{f.nombre}</span>
                        <span style={{ fontSize: 12.5, fontWeight: 500, color: plan.color, whiteSpace: "nowrap" }}>{plan.label}</span>
                      </div>
                      <StepperFases p={p} />
                      {plan.sub && <div style={{ marginTop: 8, fontSize: 12.5, color: plan.color === "var(--risk)" ? "var(--risk)" : "var(--muted)" }}>{plan.sub}</div>}
                    </div>
                    <div style={{ display: "flex", gap: "4px 16px", flexWrap: "wrap", fontSize: 12.5, color: "var(--muted)", marginTop: "auto" }}>
                      <span><span className="mono" style={{ color: "var(--text)" }}>{abiertas}</span> tareas abiertas</span>
                      {bloq > 0 && <span style={{ color: "var(--risk)" }}><span className="mono">{bloq}</span> bloqueada{bloq > 1 ? "s" : ""}</span>}
                      <span style={{ marginLeft: "auto" }}>{nombreEquipo(p.responsable_id)}</span>
                    </div>
                  </div>
                  <div style={{ borderLeft: "1px solid var(--border)", paddingLeft: 24, minWidth: 0 }}>
                    <KpiGrande p={p} onClick={() => nav(`/proyectos/${p.id}/indicador`)} />
                  </div>
                </article>
              );
            })}
          </div>
        </section>
      )}
      {porA.length > 0 && (
        <section style={{ marginBottom: 28 }}>
          <CabeceraSeccion titulo="Por arrancar" n={porA.length} />
          <div className="lista">{porA.map((p) => fila(p, <span className="abierto" style={{ fontSize: 12.5, borderRadius: "var(--r-control)", padding: "3px 8px", whiteSpace: "nowrap" }}>Propuesta aceptada · arranca al firmar baseline</span>))}</div>
        </section>
      )}
      {cerr.length > 0 && (
        <section>
          <CabeceraSeccion titulo="Cerrados" n={cerr.length} />
          <div className="lista">{cerr.map((p) => { const st = estadoKpi(p), k = p.indicador, last = k.lecturas[k.lecturas.length - 1]; return fila(p, <><span className="mono" style={{ color: "var(--muted)" }}>{k.baseline}{unidad(k)} → <span style={{ color: "var(--text)" }}>{last?.valor ?? "—"}{unidad(k)}</span></span><PillKpi st={st} /><span className="mono" style={{ color: "var(--faint)" }}>{fmtFecha(p.cierre)}</span></>); })}</div>
        </section>
      )}
    </div>
  );
}
